import React, { useEffect, useState } from 'react';
import Modal from '../../../ui/Modal';

const KZT = new Intl.NumberFormat('ru-KZ', { maximumFractionDigits: 2 });

const formatDate = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    timeZone: 'Europe/Moscow',
  });
};

function StatusBadge({ name }) {
  const n = String(name || '').toLowerCase();
  let tone = 'neutral';
  if (/ожидает|новая/.test(n))           tone = 'warning';
  else if (/подтверждена|готов|оплачен|доставлен|закрыт|завершен/.test(n)) tone = 'success';
  else if (/отмен|возврат|отклон/.test(n))     tone = 'danger';
  else if (/в пути|производ|собира/.test(n))   tone = 'info';
  return <span className={`crmpage__status crmpage__status--${tone}`}>{name || '—'}</span>;
}

const PaymentStatusProductPositions = ({ orders, oDetails, onClose, clientName }) => {
  const [paymentStatus, setPaymentStatus] = useState('—');

  useEffect(() => {
    if (orders && orders.length > 0) {
      const orderId = orders[0].id_orders;
      (async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}v1/orders/${orderId}`);
          if (!response.ok) return;
          const orderData = await response.json();
          const s = orderData.id_payment_status;
          setPaymentStatus(s === 1 ? 'Оплачено' : s === 2 ? 'Ожидает оплаты' : '—');
        } catch (error) { console.error(error); }
      })();
    }
  }, [orders]);

  if (!orders || orders.length === 0) return null;

  const items = Array.isArray(oDetails?.items)
    ? oDetails.items.filter(i => Number(i['Количество']) > 0)
    : [];
  const first = orders[0];

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={`Заявка №${first.order_number}`}
      subtitle={clientName}
      size="lg"
    >
      <div className="uimodal-field">
        <span className="uimodal-field__label">Договор</span>
        <span className="uimodal-field__value">{first.contract_info || '—'}</span>
      </div>
      <div className="uimodal-field">
        <span className="uimodal-field__label">Адрес доставки</span>
        <span className="uimodal-field__value">{first.delivery_address || '—'}</span>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Дата заказа</span>
          <span className="uimodal-field__value">{formatDate(first.order_date)}</span>
        </div>
        <div>
          <span className="uimodal-field__label">Дата доставки</span>
          <span className="uimodal-field__value">{formatDate(first.delivery_date)}</span>
        </div>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Статус заказа</span>
          <span className="uimodal-field__value"><StatusBadge name={first.status_name} /></span>
        </div>
        <div>
          <span className="uimodal-field__label">Статус оплаты</span>
          <span className="uimodal-field__value"><StatusBadge name={paymentStatus} /></span>
        </div>
      </div>

      <table className="uimodal-table">
        <thead>
          <tr>
            <th>Товар</th>
            <th className="num">Кол-во</th>
            <th className="num">Цена</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? items.map((item, index) => {
            const qty = Number(item['Количество'] || 0);
            const price = Number(item['Цена'] || 0);
            return (
              <tr key={index}>
                <td>{item['Товар']}</td>
                <td className="num">{qty}</td>
                <td className="num">{KZT.format(price)} ₸</td>
                <td className="num">{KZT.format(qty * price)} ₸</td>
              </tr>
            );
          }) : (
            <tr><td colSpan={4} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>Позиций нет</td></tr>
          )}
        </tbody>
      </table>

      <div className="uimodal-total">
        <span className="uimodal-total__label">Итоговая сумма</span>
        <span className="uimodal-total__value">{KZT.format(first.total_amount || 0)} ₸</span>
      </div>
    </Modal>
  );
};

export default PaymentStatusProductPositions;
